/**
 * @file
 * A JavaScript file containing the carousel functionality
 */

(function (Drupal, $) {
  Drupal.behaviors.profileListCarousel = {
    attach: function (context) {
      $(document).ready(function () {
        $(once("profile-list-processed", ".profile-list", context))
          .addClass("profile-list-processed")
          .each(function () {
            console.log("test");
            $(".profile-list .profile-list__list-carousel").slick({
              dots: false,
              infinite: false,
              speed: 400,
              slidesToShow: 1,
              slidesToScroll: 1,
              mobileFirst: true,
              variableWidth: false,
              centerMode: false,
              draggable: true,
              prevArrow:
                ".profile-list .profile-list__control-buttons .btn-prev",
              nextArrow:
                ".profile-list .profile-list__control-buttons .btn-next",
              responsive: [
                {
                  breakpoint: 1350,
                  settings: {
                    slidesToShow: 6,
                    slidesToScroll: 6,
                  },
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                  },
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  },
                },
              ],
            });
          });
      });
    },
  };
})(Drupal, jQuery);
